<template>
    <div class="bg-white">
        <Head title="Início" />
        <HeaderTop />
        <Header class="pt-20" />

        <div class="container mx-auto px-4 py-4 flex flex-col lg:flex-row gap-8">
            <div class="lg:w-2/3">
                <WeatherCard />
                <Sorteios :sorteios="sorteios" />
                <NewsSection :noticias="noticias" :atividades_hoje="atividades_hoje" :videos="videos" />

                <div v-if="selos?.length">
                    <div class="flex flex-wrap items-center gap-4">
                        <div v-for="item in selos" :key="item.id"
                            class="relative flex items-center justify-center group">
                            <img
                                v-if="item.path_imagem"
                                :src="`/storage/${item.path_imagem}`"
                                :alt="item.descricao || 'Selo'"
                                class="h-20 w-auto object-contain"
                            />
                            <div v-else class="h-12 w-12 bg-gray-100 rounded flex items-center justify-center text-gray-400">
                                <ImageIcon class="w-5 h-5" />
                            </div>
                            <div v-if="item.descricao"
                                class="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 px-2 py-1 bg-gray-800 text-white text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
                                {{ item.descricao }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lg:w-1/3 space-y-6">
                <SidebarCards :acesso_rapido="acesso_rapido" />
            </div>
        </div>
        <Footer />
        <CookieBanner />
        <AlertaModal v-if="alertas && alertas.length > 0" :alertas="alertas" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Head, usePage } from '@inertiajs/vue3';
import HeaderTop from '@/Components/Welcom/HeaderTop.vue'
import Header from '@/Components/Welcom/Header.vue'
import NewsSection from '@/Components/Welcom/NewsSection.vue'
import SidebarCards from '@/Components/Welcom/SidebarCards.vue'
import Footer from '@/Components/Welcom/Footer.vue'
import CookieBanner from '@/Components/CookieBanner.vue'
import AlertaModal from '@/Components/Alertas/AlertaModal.vue'
import WeatherCard from '@/Components/Weather/WeatherCard.vue'
import Sorteios from '@/Components/Welcom/Sorteios.vue'
import { Image as ImageIcon } from 'lucide-vue-next'

const props = defineProps({
    acesso_rapido:   { type: Array, required: true },
    noticias:        { type: Array, required: true },
    atividades_hoje: { type: Array, default: () => [] },
    selos:           { type: Array, default: () => [] },
    videos:          { type: Array, default: () => [] },
    sorteios:        { type: Array, default: () => [] },
});

// Obter alertas compartilhados via Inertia
const page = usePage();
const alertas = ref(page.props.alertas || []);
</script>
